import React from 'react';
import { useDispatch } from 'react-redux';
import { Breadcrumb, Card, Form, Input, Button, Switch, message, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-feather';
import {
  communityActionStarts,
  communityActionErrors,
  createCommunityAction,
} from '../../core/data/redux/modules/community/actions';
import { createCommunity } from '../../services/communityServices';

const { Title } = Typography;
const { TextArea } = Input;

const CreateCommunity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    dispatch(communityActionStarts());
    try {
      const communityData = {
        ...values,
        is_private: values.is_private || false,
      };
      
      const res = await createCommunity(communityData);
      if (res.error === true) throw new Error(res.message || 'Error creating community');
      
      dispatch(createCommunityAction(res.data));
      message.success('Community created successfully');
      navigate('/admin/community-management');
    } catch (err: any) {
      dispatch(communityActionErrors(err.message));
      message.error(err.message);
    }
  };

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/community-management">Community Management</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create Community</Breadcrumb.Item>
        </Breadcrumb>
        
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Create New Community</Title>
          
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              is_private: false,
            }}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: 'Please enter community name' }]}
            >
              <Input placeholder="Enter community name" />
            </Form.Item>

            <Form.Item
              label="Unique Name"
              name="unique_name"
              rules={[{ required: true, message: 'Please enter unique name' }]}
            >
              <Input placeholder="Enter unique name (e.g., my-community)" />
            </Form.Item>

            <Form.Item
              label="Guideline (Optional)"
              name="guideline"
            >
              <TextArea rows={4} placeholder="Enter community guidelines..." />
            </Form.Item>

            <Form.Item
              label="Private Community"
              name="is_private"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item>
              <div style={{ display: 'flex', gap: 8 }}>
                <Button type="primary" htmlType="submit" icon={<Icon.Save size={16} />}>
                  Create Community
                </Button>
                <Button onClick={() => navigate('/admin/community-management')}>
                  Cancel
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default CreateCommunity;
